import axiosClient from "../../../../api/axiosClient";

export const fetchCategories = async (token) => {
  axiosClient.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  const response = await axiosClient.get("/categories"); // endpoint API categories
  return response.data.data; // pastikan API mengembalikan array category
};
